"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightTheme = void 0;
const typography_1 = require("../../typography");
const shadows_1 = require("./shadows");
const colors_1 = require("./colors");
exports.lightTheme = {
    colors: colors_1.colors,
    typography: typography_1.typography,
    shadows: shadows_1.shadows,
};
//# sourceMappingURL=lightTheme.js.map